// extracted by mini-css-extract-plugin
export var infoItem = "_o2-2";
export var title = "_o2-0";
export var value = "_o2-1";